/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import type {
    APIErrorResponseResponse,
    CreateUpgradePathBodyBody,
    CreateUpgradePathResponseResponse,
    DismissUpgradeOfferBodyBody,
    GetUpgradeOffersParams,
    RequestStatusResponseResponse,
    SendBulkUpgradeOfferBodyBody,
    SendBulkUpgradeOfferResponseResponse,
    UpgradeOffersListResponseResponse,
    UpgradePathsListResponseResponse,
} from '.././model';

import { customInstance } from '.././custom-axios-instance';

/**
 * @summary List upgrade paths for a show
 */
export const getUpgradePaths = (showId: number, signal?: AbortSignal) => {
    return customInstance<UpgradePathsListResponseResponse>({
        url: `/shows/${showId}/upgrade-paths`,
        method: 'GET',
        signal,
    });
};

export const getGetUpgradePathsQueryKey = (showId?: number) => {
    return [`/shows/${showId}/upgrade-paths`] as const;
};

export const getGetUpgradePathsQueryOptions = <
    TData = Awaited<ReturnType<typeof getUpgradePaths>>,
    TError = APIErrorResponseResponse,
>(
    showId: number,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getUpgradePaths>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetUpgradePathsQueryKey(showId);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUpgradePaths>>> = ({ signal }) =>
        getUpgradePaths(showId, signal);

    return { queryKey, queryFn, enabled: !!showId, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getUpgradePaths>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetUpgradePathsQueryResult = NonNullable<Awaited<ReturnType<typeof getUpgradePaths>>>;
export type GetUpgradePathsQueryError = APIErrorResponseResponse;

/**
 * @summary List upgrade paths for a show
 */

export function useGetUpgradePaths<
    TData = Awaited<ReturnType<typeof getUpgradePaths>>,
    TError = APIErrorResponseResponse,
>(
    showId: number,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getUpgradePaths>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetUpgradePathsQueryOptions(showId, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Create an upgrade path
 */
export const createUpgradePath = (
    showId: number,
    createUpgradePathBodyBody: CreateUpgradePathBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<CreateUpgradePathResponseResponse>({
        url: `/shows/${showId}/upgrade-paths`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createUpgradePathBodyBody,
        signal,
    });
};

export const getCreateUpgradePathMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof createUpgradePath>>,
        TError,
        { showId: number; data: CreateUpgradePathBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof createUpgradePath>>,
    TError,
    { showId: number; data: CreateUpgradePathBodyBody },
    TContext
> => {
    const mutationKey = ['createUpgradePath'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof createUpgradePath>>,
        { showId: number; data: CreateUpgradePathBodyBody }
    > = (props) => {
        const { showId, data } = props ?? {};

        return createUpgradePath(showId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type CreateUpgradePathMutationResult = NonNullable<
    Awaited<ReturnType<typeof createUpgradePath>>
>;
export type CreateUpgradePathMutationBody = CreateUpgradePathBodyBody;
export type CreateUpgradePathMutationError = APIErrorResponseResponse;

/**
 * @summary Create an upgrade path
 */
export const useCreateUpgradePath = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof createUpgradePath>>,
        TError,
        { showId: number; data: CreateUpgradePathBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof createUpgradePath>>,
    TError,
    { showId: number; data: CreateUpgradePathBodyBody },
    TContext
> => {
    const mutationOptions = getCreateUpgradePathMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Delete an upgrade path
 */
export const deleteUpgradePath = (showId: number, upgradePathId: number) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/shows/${showId}/upgrade-paths/${upgradePathId}`,
        method: 'DELETE',
    });
};

export const getDeleteUpgradePathMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteUpgradePath>>,
        TError,
        { showId: number; upgradePathId: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteUpgradePath>>,
    TError,
    { showId: number; upgradePathId: number },
    TContext
> => {
    const mutationKey = ['deleteUpgradePath'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteUpgradePath>>,
        { showId: number; upgradePathId: number }
    > = (props) => {
        const { showId, upgradePathId } = props ?? {};

        return deleteUpgradePath(showId, upgradePathId);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteUpgradePathMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteUpgradePath>>
>;

export type DeleteUpgradePathMutationError = APIErrorResponseResponse;

/**
 * @summary Delete an upgrade path
 */
export const useDeleteUpgradePath = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteUpgradePath>>,
        TError,
        { showId: number; upgradePathId: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof deleteUpgradePath>>,
    TError,
    { showId: number; upgradePathId: number },
    TContext
> => {
    const mutationOptions = getDeleteUpgradePathMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary List upgrade offers and eligible bookings
 */
export const getUpgradeOffers = (params?: GetUpgradeOffersParams, signal?: AbortSignal) => {
    return customInstance<UpgradeOffersListResponseResponse>({
        url: `/upgrade-offers`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetUpgradeOffersQueryKey = (params?: GetUpgradeOffersParams) => {
    return [`/upgrade-offers`, ...(params ? [params] : [])] as const;
};

export const getGetUpgradeOffersQueryOptions = <
    TData = Awaited<ReturnType<typeof getUpgradeOffers>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetUpgradeOffersParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getUpgradeOffers>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetUpgradeOffersQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUpgradeOffers>>> = ({ signal }) =>
        getUpgradeOffers(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getUpgradeOffers>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetUpgradeOffersQueryResult = NonNullable<Awaited<ReturnType<typeof getUpgradeOffers>>>;
export type GetUpgradeOffersQueryError = APIErrorResponseResponse;

/**
 * @summary List upgrade offers and eligible bookings
 */

export function useGetUpgradeOffers<
    TData = Awaited<ReturnType<typeof getUpgradeOffers>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetUpgradeOffersParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getUpgradeOffers>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetUpgradeOffersQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Send upgrade offers to multiple bookings
 */
export const sendBulkUpgradeOffer = (
    sendBulkUpgradeOfferBodyBody: SendBulkUpgradeOfferBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<SendBulkUpgradeOfferResponseResponse>({
        url: `/upgrade-offers/send-bulk`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: sendBulkUpgradeOfferBodyBody,
        signal,
    });
};

export const getSendBulkUpgradeOfferMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof sendBulkUpgradeOffer>>,
        TError,
        { data: SendBulkUpgradeOfferBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof sendBulkUpgradeOffer>>,
    TError,
    { data: SendBulkUpgradeOfferBodyBody },
    TContext
> => {
    const mutationKey = ['sendBulkUpgradeOffer'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof sendBulkUpgradeOffer>>,
        { data: SendBulkUpgradeOfferBodyBody }
    > = (props) => {
        const { data } = props ?? {};

        return sendBulkUpgradeOffer(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type SendBulkUpgradeOfferMutationResult = NonNullable<
    Awaited<ReturnType<typeof sendBulkUpgradeOffer>>
>;
export type SendBulkUpgradeOfferMutationBody = SendBulkUpgradeOfferBodyBody;
export type SendBulkUpgradeOfferMutationError = APIErrorResponseResponse;

/**
 * @summary Send upgrade offers to multiple bookings
 */
export const useSendBulkUpgradeOffer = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof sendBulkUpgradeOffer>>,
        TError,
        { data: SendBulkUpgradeOfferBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof sendBulkUpgradeOffer>>,
    TError,
    { data: SendBulkUpgradeOfferBodyBody },
    TContext
> => {
    const mutationOptions = getSendBulkUpgradeOfferMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Re-send upgrade offer email
 */
export const sendUpgradeReminder = (upgradeOfferId: number, signal?: AbortSignal) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/upgrade-offers/${upgradeOfferId}/send-reminder`,
        method: 'POST',
        signal,
    });
};

export const getSendUpgradeReminderMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof sendUpgradeReminder>>,
        TError,
        { upgradeOfferId: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof sendUpgradeReminder>>,
    TError,
    { upgradeOfferId: number },
    TContext
> => {
    const mutationKey = ['sendUpgradeReminder'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof sendUpgradeReminder>>,
        { upgradeOfferId: number }
    > = (props) => {
        const { upgradeOfferId } = props ?? {};

        return sendUpgradeReminder(upgradeOfferId);
    };

    return { mutationFn, ...mutationOptions };
};

export type SendUpgradeReminderMutationResult = NonNullable<
    Awaited<ReturnType<typeof sendUpgradeReminder>>
>;

export type SendUpgradeReminderMutationError = APIErrorResponseResponse;

/**
 * @summary Re-send upgrade offer email
 */
export const useSendUpgradeReminder = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof sendUpgradeReminder>>,
        TError,
        { upgradeOfferId: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof sendUpgradeReminder>>,
    TError,
    { upgradeOfferId: number },
    TContext
> => {
    const mutationOptions = getSendUpgradeReminderMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Dismiss an upgrade offer or booking (offer → rollback, booking → declined)
 */
export const dismissUpgradeOffer = (
    dismissUpgradeOfferBodyBody: DismissUpgradeOfferBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/upgrade-offers/dismiss`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: dismissUpgradeOfferBodyBody,
        signal,
    });
};

export const getDismissUpgradeOfferMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof dismissUpgradeOffer>>,
        TError,
        { data: DismissUpgradeOfferBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof dismissUpgradeOffer>>,
    TError,
    { data: DismissUpgradeOfferBodyBody },
    TContext
> => {
    const mutationKey = ['dismissUpgradeOffer'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof dismissUpgradeOffer>>,
        { data: DismissUpgradeOfferBodyBody }
    > = (props) => {
        const { data } = props ?? {};

        return dismissUpgradeOffer(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type DismissUpgradeOfferMutationResult = NonNullable<
    Awaited<ReturnType<typeof dismissUpgradeOffer>>
>;
export type DismissUpgradeOfferMutationBody = DismissUpgradeOfferBodyBody;
export type DismissUpgradeOfferMutationError = APIErrorResponseResponse;

/**
 * @summary Dismiss an upgrade offer or booking (offer → rollback, booking → declined)
 */
export const useDismissUpgradeOffer = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof dismissUpgradeOffer>>,
        TError,
        { data: DismissUpgradeOfferBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof dismissUpgradeOffer>>,
    TError,
    { data: DismissUpgradeOfferBodyBody },
    TContext
> => {
    const mutationOptions = getDismissUpgradeOfferMutationOptions(options);

    return useMutation(mutationOptions);
};
